<template>
    <section class="hot-panel-text">
        <section-title :title="title" />
        <div>
            <p v-for="(item, idx) in list" :key="idx" class="text">{{ item.name }}</p>
        </div>
    </section>
</template>

<script>
import SectionTitle from './sectionTitle';

export default {
    name: 'HotPanelText',
    components: {
        SectionTitle
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        list: {
            type: Array,
            default: () => []
        }
    }
};
</script>

<style lang="less" scoped>
.hot-panel-text {
    .text {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 18px;
        color: #1e2330;
        margin-top: 6px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: left;

        &:first-child {
            margin-top: 0;
        }
    }
}
</style>
